import { tv, type VariantProps } from "@ui/lib/tv";
import type { CSSProperties } from "react";
import { SwooshSweep } from "./SwooshSweep";

export const swooshColor = tv({
  base: "pointer-events-none",
  variants: {
    color: {
      red: "text-red-50",
      yellow: "text-yellow-50",
      purple: "text-purple-100",
    },
  },
});

export type SwooshColor = Required<VariantProps<typeof swooshColor>>["color"];

// Component-private SVG sizing and positioning — kept inline rather than as Tailwind
// utilities because these magic-number offsets aren't reusable design tokens. Also
// sidesteps Tailwind v4 not emitting arbitrary vw widths with decimal values
// (`w-[167.5vw]`) or percent translates (`translate-y-[<percent>]`).
const SWOOSH_STYLE: CSSProperties = { width: "167.5vw", translate: "-25.25% -39.2%" };

/** Full-viewport decorative swoosh background. Renders the dramatic two-path SVG sized to Figma specs. Expects its parent to handle positioning, overflow, and z-ordering. */
export interface SwooshBackgroundProps {
  /** Color variant: red (family), yellow (community), purple (individual). */
  color: SwooshColor;
  /** Extra classes — typically used by consumers to hide the desktop swoosh on mobile
   *  (e.g. `hidden md:block`) when paired with `SwooshStrip` as the mobile counterpart. */
  className?: string;
}

export function SwooshBackground({ color, className }: SwooshBackgroundProps) {
  return (
    <SwooshSweep
      className={swooshColor({
        color,
        className: `h-auto${className ? ` ${className}` : ""}`,
      })}
      style={SWOOSH_STYLE}
    />
  );
}
